import type { SVGAttributes } from 'react';
import { cn } from '../../lib/cn';

type Size = 'xs' | 'sm' | 'md' | 'lg';

interface Props extends Omit<SVGAttributes<SVGSVGElement>, 'children'> {
  readonly size?: Size;
  readonly ariaLabel?: string;
}

const dimensions: Record<Size, number> = {
  xs: 12,
  sm: 16,
  md: 20,
  lg: 28,
};

export function Spinner({ size = 'sm', ariaLabel = 'Loading', className, ...rest }: Props) {
  const px = dimensions[size];
  return (
    <svg
      role="status"
      aria-label={ariaLabel}
      aria-busy="true"
      width={px}
      height={px}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('orb-spinner', className)}
      {...rest}
    >
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeOpacity="0.18"
      />
      <path
        d="M21 12a9 9 0 0 0-9-9"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
